/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://26ygrze3kngkbkhl7vzqrnowg4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-skyetfocsvdmzil57a5mdk3wty",
    "aws_cognito_identity_pool_id": "us-east-2:0f19d4dd-53e6-40fc-866f-1a578f1f34a1",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_5lN7TgACl",
    "aws_user_pools_web_client_id": "2nl360eb8k99v719g8n2bjlbof",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "NAME",
        "PREFERRED_USERNAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "audiofiles-awsgame2d0e1-staging",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "predictions": {
        "convert": {
            "transcription": {
                "region": "us-east-2",
                "proxy": false,
                "defaults": {
                    "language": "en-US"
                }
            }
        }
    }
};


export default awsmobile;
